import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "selector-subheader"
}
const _hoisted_2 = { class: "selector-subheader__label" }
const _hoisted_3 = {
  key: 0,
  class: "aux-del-row"
}
const _hoisted_4 = { class: "aux-tmpl-name" }
const _hoisted_5 = ["aria-label", "onClick"]
const _hoisted_6 = {
  key: 1,
  class: "aux-del-row"
}
const _hoisted_7 = ["aria-label", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selector_search_header = _resolveComponent("selector-search-header")!
  const _component_tag_selector = _resolveComponent("tag-selector")!
  const _component_recursive_selector_refactored = _resolveComponent("recursive-selector-refactored")!
  const _component_custom_hints_grid = _resolveComponent("custom-hints-grid")!
  const _component_simple_element = _resolveComponent("simple-element")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_parameter_inline_display = _resolveComponent("parameter-inline-display")!
  const _component_bill_row = _resolveComponent("bill-row")!
  const _component_counterparty_row = _resolveComponent("counterparty-row")!
  const _component_simple_selector = _resolveComponent("simple-selector")!
  const _component_confirm_action_popup = _resolveComponent("confirm-action-popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'aux-selector--templates': _ctx.isCommentTemplates }),
    style: _normalizeStyle(_ctx.containerStyle)
  }, [
    (_ctx.showSearchHeader)
      ? (_openBlock(), _createBlock(_component_selector_search_header, {
          key: 0,
          ref: "search_header",
          modelValue: _ctx.filterString,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterString) = $event)),
          "new-value-label": _ctx.newValueLabel,
          "show-close-button": !_ctx.hideCloseButton,
          "hide-search-icon": _ctx.isCommentTemplates,
          "use-own-clear-button": _ctx.isCommentTemplates,
          "free-input-tooltip": _ctx.isCommentTemplates ? _ctx.$t('create_template') : '',
          "show-free-input": 
        _ctx.allowFreeInput &&
        _ctx.filterString.length &&
        _ctx.searchCache.findIndex(
          (el) => el.Name.toLowerCase() === _ctx.filterString.toLowerCase(),
        ) < 0
      ,
          onKeyDown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trackArrowDown(1))),
          onKeyUp: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trackArrowUp(1))),
          onKeyEnter: _cache[3] || (_cache[3] = 
        () => {
          if (_ctx.allowFreeInput && _ctx.filterString.length > 0) {
            _ctx.emitFreeInput(_ctx.filterString);
          } else {
            _ctx.selectCurrent();
          }
        }
      ),
          onInputPressed: _cache[4] || (_cache[4] = 
        () => {
          if (_ctx.allowFreeInput && _ctx.filterString.length > 0) {
            _ctx.emitFreeInput(_ctx.filterString);
            if (!_ctx.isCommentTemplates) _ctx.closeItemMenu();
          }
        }
      ),
          onClose: _ctx.closeItemMenu
        }, null, 8, ["modelValue", "new-value-label", "show-close-button", "hide-search-icon", "use-own-clear-button", "free-input-tooltip", "show-free-input", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showSearchHeader && _ctx.limitHeightToContainer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.isTag ? _ctx.tagSegmentLabel : _ctx.$t(_ctx.strategy.label)), 1),
          _createElementVNode("span", {
            class: "selector-subheader__reset",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetSelection && _ctx.resetSelection(...args)))
          }, _toDisplayString(_ctx.$t("selector_reset")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "row justify-center",
      style: _normalizeStyle(_ctx.innerStyle),
      ref: "innerSpace"
    }, [
      (_ctx.isTag)
        ? (_openBlock(), _createBlock(_component_tag_selector, {
            key: 0,
            filter_string: _ctx.filterString,
            "m-height": _ctx.containerHeightPx > 0 ? _ctx.containerHeightPx : _ctx.height_variable,
            full: _ctx.full,
            "data-to-entity": _ctx.resolvedFromFilter,
            "data-from-entity": _ctx.resolvedToFilter,
            modelValue: _ctx.theModel,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.theModel) = $event))
          }, null, 8, ["filter_string", "m-height", "full", "data-to-entity", "data-from-entity", "modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.isParameter)
        ? (_openBlock(), _createBlock(_component_recursive_selector_refactored, {
            key: 1,
            ref: "simple_selector",
            "take-ids-only": false,
            "allow-multiple": true,
            "element-type": 9,
            modelValue: _ctx.theModel,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.theModel) = $event)),
            "open-on-start": _ctx.openOnStart,
            "filter-string": _ctx.filterString,
            viewport: _ctx.$refs.innerSpace,
            "return-type": "none",
            "nested-key-name": "FieldFilters",
            "entity-inside-name": "Parameter"
          }, null, 8, ["modelValue", "open-on-start", "filter-string", "viewport"]))
        : (_ctx.isCustomHints)
          ? (_openBlock(), _createBlock(_component_custom_hints_grid, {
              key: 2,
              "hints-data": _ctx.customHintsData,
              titles: _ctx.customHintsTitles,
              loading: _ctx.customHintsLoading,
              "m-height": _ctx.effectiveListHeightPx,
              onHintSelected: _ctx.onCustomHintSelected
            }, null, 8, ["hints-data", "titles", "loading", "m-height", "onHintSelected"]))
          : (_openBlock(), _createBlock(_component_simple_selector, {
              key: 3,
              ref: "simple_selector",
              "data-to-entity": _ctx.resolvedFromFilter,
              "data-from-entity": _ctx.resolvedToFilter,
              "object-filter": _ctx.strategy.isObjectFilter,
              "load-more": _ctx.boundLoadMore,
              filter_value: _ctx.strategy.isObjectFilter ? _ctx.filterModel : _ctx.filterString,
              "m-height": _ctx.effectiveListHeightPx,
              "element-type": _ctx.strategy.elementType,
              "storage-for-filter": _ctx.storageForFilterValue,
              "hide-checkboxes": _ctx.effectiveHideCheckboxes,
              "show-select-all": !!_ctx.strategy.singleLoad,
              "single-load": !!_ctx.strategy.singleLoad,
              "empty-hint": _ctx.emptyHintKey,
              "no-matches-hint": _ctx.noMatchesHintKey,
              full: _ctx.fullForSimpleSelector,
              onItemSelected: _ctx.onItemSelected,
              onEmptyClick: _cache[10] || (_cache[10] = 
          (e) => {
            if (_ctx.allowFreeInput) {
              _ctx.emitFreeInput('');
            }
            _ctx.closeItemMenu();
          }
        ),
              modelValue: _ctx.theModel,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.theModel) = $event)),
              "allow-multiple": _ctx.effectiveAllowMultiple,
              "has-deps": _ctx.strategy.hasDeps,
              "is-storages-mode": _ctx.isStoragesMode
            }, {
              item: _withCtx(({ item }) => [
                (_ctx.isCommentTemplates)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, [
                        _createVNode(_component_simple_element, {
                          element: item,
                          elementType: _ctx.strategy.elementType,
                          filter_string: _ctx.filterString
                        }, null, 8, ["element", "elementType", "filter_string"]),
                        (item.Text)
                          ? (_openBlock(), _createBlock(_component_q_tooltip, {
                              key: 0,
                              delay: 300,
                              anchor: "top left",
                              self: "bottom left",
                              offset: [0, 0],
                              class: "aux-sel-tooltip aux-sel-tooltip--text"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.Text), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.canDeleteListItems)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "aux-del",
                            "aria-label": _ctx.$t('delete_template'),
                            onMousedown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop","prevent"])),
                            onClick: _withModifiers(($event: any) => (_ctx.openDeleteConfirm($event, item)), ["stop"])
                          }, [
                            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "aux-del__ico" }, null, -1)),
                            _createVNode(_component_q_tooltip, {
                              delay: 300,
                              anchor: "top middle",
                              self: "center middle",
                              class: "aux-sel-tooltip"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("delete_template")), 1)
                              ]),
                              _: 1
                            })
                          ], 40, _hoisted_5))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.canDeleteListItems)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_simple_element, {
                          element: item,
                          elementType: _ctx.strategy.elementType,
                          filter_string: _ctx.filterString
                        }, null, 8, ["element", "elementType", "filter_string"]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "aux-del",
                          "aria-label": _ctx.$t('remove'),
                          onMousedown: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop","prevent"])),
                          onClick: _withModifiers(($event: any) => (_ctx.openDeleteConfirm($event, item)), ["stop"])
                        }, _cache[14] || (_cache[14] = [
                          _createElementVNode("span", { class: "aux-del__ico" }, null, -1)
                        ]), 40, _hoisted_7)
                      ]))
                    : _renderSlot(_ctx.$slots, "item", {
                        key: 2,
                        item: item,
                        elementType: _ctx.strategy.elementType
                      }, () => [
                        (_ctx.strategy.elementType === _ctx.VariableType.ParameterInline)
                          ? (_openBlock(), _createBlock(_component_parameter_inline_display, {
                              key: 0,
                              id: "ds",
                              editable: false,
                              "is-table": true,
                              "model-value": _ctx.getPositionNameModel(item)
                            }, null, 8, ["model-value"]))
                          : (_ctx.strategy.elementType === _ctx.VariableType.Bill)
                            ? (_openBlock(), _createBlock(_component_bill_row, {
                                key: 1,
                                el: item.bill,
                                "bill-type": item.billRowType
                              }, null, 8, ["el", "bill-type"]))
                            : (_ctx.strategy.elementType === _ctx.VariableType.Counterparty)
                              ? (_openBlock(), _createBlock(_component_counterparty_row, {
                                  key: 2,
                                  el: item
                                }, null, 8, ["el"]))
                              : (_openBlock(), _createBlock(_component_simple_element, {
                                  key: 3,
                                  element: item,
                                  elementType: _ctx.strategy.elementType,
                                  filter_string: _ctx.filterString
                                }, null, 8, ["element", "elementType", "filter_string"]))
                      ])
              ]),
              _: 3
            }, 8, ["data-to-entity", "data-from-entity", "object-filter", "load-more", "filter_value", "m-height", "element-type", "storage-for-filter", "hide-checkboxes", "show-select-all", "single-load", "empty-hint", "no-matches-hint", "full", "onItemSelected", "modelValue", "allow-multiple", "has-deps", "is-storages-mode"]))
    ], 4),
    (_ctx.canDeleteListItems && _ctx.deleteConfirmOpen)
      ? (_openBlock(), _createBlock(_component_confirm_action_popup, {
          key: 2,
          title: _ctx.deleteConfirmTitle,
          question: "",
          "question-html": _ctx.deleteConfirmQuestionHtml,
          position: _ctx.deleteMenuPos,
          onConfirm: _ctx.confirmDelete,
          onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deleteConfirmOpen = false))
        }, null, 8, ["title", "question-html", "position", "onConfirm"]))
      : _createCommentVNode("", true)
  ], 6))
}